import React from 'react';
import { Alert, Container, Row, Button, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function EditableHeader(props) {

    return (
        <Alert variant="editable-header">
            <Container>
                <Row className="justify-content-center align-items-center">
                    <Col xs={8}>
                        <FontAwesomeIcon icon={props.icon} style={{ marginRight: 10 }} />
                        {props.header} <b>{props.selectedValue}</b>
                    </Col>
                    <Col xs={4} className="d-flex justify-content-end">
                        <Button onClick={() => props.onEdit()} variant="edit">Ändra</Button>
                    </Col>
                </Row>
            </Container>
        </Alert>
    );

}

export default EditableHeader;